import { render, staticRenderFns } from "./ClientCarrierPage.vue?vue&type=template&id=4bd8e0fd&scoped=true"
import script from "./ClientCarrierPage.vue?vue&type=script&lang=js"
export * from "./ClientCarrierPage.vue?vue&type=script&lang=js"
import style0 from "./ClientCarrierPage.vue?vue&type=style&index=0&id=4bd8e0fd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd8e0fd",
  null
  
)

export default component.exports